import coverImg from "assets/images/v49/cover.webp"
import titleImg from "assets/images/v49/title.webp"
import titleDeImg from "assets/images/v49/title-de.webp"
import titleFrImg from "assets/images/v49/title-fr.webp"
import titleHiImg from "assets/images/v49/title-hi.webp"
import { generateAppsFlyerLink } from "lib/common"
import { FormattedMessage } from "react-intl"
import { useEffect } from "react"
import { sendAmplitudeEvent } from "lib/amplitude"
import { trackMetaEvent } from "lib/meta"
import { trackSnapchatClick } from "lib/snapchat"
import { sendGoogleClickConversion } from "lib/google"
import { useParams } from "react-router-dom"
import { twMerge } from "tailwind-merge"

type PageWithCoverImages = {
  cover?: Record<string, string>
  title?: Record<string, string>
  picture?: string | Record<string, string>
  bottom?: Record<string, string>
  top?: Record<string, string>
}

type PageWithCoverProps = {
  surveyId: string
  images?: PageWithCoverImages
  buttonTextKey?: string
  theme?: {
    button?: {
      className?: string
    }
    container?: {
      className?: string
    }
    title?: {
      className?: string
    }
  }
}

const images: PageWithCoverImages = {
  cover: {
    en: coverImg,
  },
  title: {
    en: titleImg,
    de: titleDeImg,
    fr: titleFrImg,
    hi: titleHiImg,
  },
}

export function PageWithCover(props: PageWithCoverProps) {
  const imagesList = props.images || images
  const { locale = "en" } = useParams()
  const titleImage = imagesList.title?.[locale]
  const coverImage = imagesList.cover?.[locale] || imagesList.cover?.en
  const topImage = imagesList.top?.[locale] || imagesList.top?.en

  const onButtonClick = () => {
    trackMetaEvent("Lead")
    trackSnapchatClick()
    sendGoogleClickConversion(() =>
      sendAmplitudeEvent(
        "onboarding_cta_clicked",
        { onboarding: props.surveyId },
        () => {
          location.assign(generateAppsFlyerLink(props.surveyId))
        },
      ),
    )
  }

  useEffect(() => {
    sendAmplitudeEvent("onboarding_started", {
      onboarding: props.surveyId,
    })
    document.body.classList.add(`cover-${props.surveyId}`)
  }, [])

  return (
    <div
      className="relative max-w-[450px] h-full mx-auto pb-[50px] bg-cover bg-no-repeat bg-center"
      style={
        coverImage
          ? { backgroundImage: `url(${coverImage})` }
          : { background: "rgb(28, 23, 24)" }
      }
    >
      {topImage && (
        <img
          src={topImage}
          className="absolute top-[55px] left-1/2 -translate-x-1/2 max-w-[320px]"
        />
      )}
      <div
        className={twMerge(
          "absolute bottom-[50px] left-0 right-0 px-4",
          props.theme?.container?.className,
        )}
      >
        {imagesList.picture && (
          <img
            src={
              typeof imagesList.picture === "string"
                ? imagesList.picture
                : imagesList.picture[locale] || imagesList.picture.en
            }
            className="max-w-[300px] mx-auto mb-2"
          />
        )}
        {titleImage && (
          <img src={titleImage} className={props.theme?.title?.className} />
        )}
        <button
          className={twMerge(
            "bg-[#FF00FF] text-white w-full h-[56px] text-[18px] uppercase font-sans-bold tracking-wide",
            props.theme?.button?.className,
          )}
          onClick={onButtonClick}
        >
          <FormattedMessage id={props.buttonTextKey || "button.download"} />
        </button>
        {imagesList.bottom?.[locale] && (
          <img src={imagesList.bottom?.[locale]} />
        )}
      </div>
    </div>
  )
}
